import React, { Component } from 'react';
import { formatDate } from './shared/formatters';
import AuthService from '../AuthService';
import constants from '../../config';

var Auth = new AuthService();

var TYPE_LABELS = {
  suspend: { label: 'Suspend', color: '#f59e0b', icon: 'fa-pause-circle' },
  ban: { label: 'Ban', color: '#EF4444', icon: 'fa-ban' },
  unsuspend: { label: 'Unsuspend', color: '#10B981', icon: 'fa-check-circle' },
  unban: { label: 'Unban', color: '#10B981', icon: 'fa-check-circle' },
  listing_removed: { label: 'Listing Removed', color: '#EF4444', icon: 'fa-trash' },
  order_confirmation: { label: 'Order Confirmation', color: '#3B82F6', icon: 'fa-shopping-cart' },
  payout: { label: 'Payout', color: '#10B981', icon: 'fa-money' },
  verification: { label: 'Verification', color: '#8B5CF6', icon: 'fa-envelope' },
  password_reset: { label: 'Password Reset', color: '#f59e0b', icon: 'fa-lock' },
};

class AdminNotificationLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logs: [],
      pagination: { page: 1, limit: 50, total: 0, pages: 0 },
      loading: true,
      filterType: '',
      filterStatus: '',
      filterTo: '',
    };
    this.fetchLogs = this.fetchLogs.bind(this);
  }

  componentDidMount() {
    this.fetchLogs(1);
  }

  fetchLogs(page) {
    var self = this;
    self.setState({ loading: true });
    var params = ['page=' + page, 'limit=50'];
    if (self.state.filterType) params.push('type=' + encodeURIComponent(self.state.filterType));
    if (self.state.filterStatus) params.push('status=' + encodeURIComponent(self.state.filterStatus));
    if (self.state.filterTo) params.push('to=' + encodeURIComponent(self.state.filterTo));

    Auth.fetch(constants.DOMAIN + '/api/v1/admin/notification-log?' + params.join('&'))
      .then(function(data) {
        self.setState({
          logs: data.logs || [],
          pagination: data.pagination || { page: 1, limit: 50, total: 0, pages: 0 },
          loading: false,
        });
      })
      .catch(function(err) { console.log('Failed to fetch notification log:', err); self.setState({ loading: false }); });
  }

  render() {
    var self = this;
    var isDark = document.documentElement.classList.contains('tw-dark');
    var logs = this.state.logs;
    var pagination = this.state.pagination;

    return (
      <div>
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
          <div>
            <h1 className="tw-text-xl tw-font-bold tw-text-[#1a1a1a] dark:tw-text-white tw-m-0">Notification Log</h1>
            <p className="tw-text-sm tw-text-[#999] tw-m-0 tw-mt-0.5">Email notifications sent by the platform</p>
          </div>
          <span className="tw-text-sm tw-text-[#999]">{pagination.total} total</span>
        </div>

        {/* Filters */}
        <div className="tw-flex tw-flex-wrap tw-gap-3 tw-mb-4">
          <select
            value={this.state.filterType}
            onChange={function(e) { self.setState({ filterType: e.target.value }, function() { self.fetchLogs(1); }); }}
            className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-min-w-[140px]"
          >
            <option value="">All Types</option>
            {Object.keys(TYPE_LABELS).map(function(t) {
              return <option key={t} value={t}>{TYPE_LABELS[t].label}</option>;
            })}
          </select>
          <select
            value={this.state.filterStatus}
            onChange={function(e) { self.setState({ filterStatus: e.target.value }, function() { self.fetchLogs(1); }); }}
            className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white"
          >
            <option value="">All Status</option>
            <option value="sent">Sent</option>
            <option value="failed">Failed</option>
          </select>
          <input
            type="text"
            value={this.state.filterTo}
            onChange={function(e) { self.setState({ filterTo: e.target.value }); }}
            onKeyDown={function(e) { if (e.key === 'Enter') self.fetchLogs(1); }}
            placeholder="Search recipient email..."
            className="tw-px-3 tw-py-2 tw-rounded-lg tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-sm tw-text-[#1a1a1a] dark:tw-text-white tw-w-64"
          />
        </div>

        {this.state.loading ? (
          <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
            <div className="tw-text-center">
              <i className="fa fa-circle-o-notch fa-spin tw-text-3xl tw-mb-3" style={{ color: '#D4A843', display: 'block' }} />
              <span className="tw-text-sm tw-text-[#999]">Loading...</span>
            </div>
          </div>
        ) : logs.length === 0 ? (
          <div className="tw-rounded-xl tw-p-8 tw-text-center" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <i className="fa fa-envelope-o tw-text-3xl tw-mb-3" style={{ color: '#999', display: 'block' }} />
            <p className="tw-text-[#999] tw-text-sm tw-m-0">No notification logs found</p>
          </div>
        ) : (
          <div className="tw-rounded-xl tw-overflow-hidden" style={{ backgroundColor: isDark ? '#1a1a1a' : '#fff', border: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
            <div className="tw-overflow-x-auto">
              <table className="tw-w-full tw-text-sm" style={{ borderCollapse: 'collapse' }}>
                <thead>
                  <tr className="tw-text-left tw-text-xs tw-text-[#999]" style={{ backgroundColor: isDark ? '#111' : 'rgba(0,0,0,0.02)', borderBottom: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">Date</th>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">Type</th>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">To</th>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">Subject</th>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">User</th>
                    <th className="tw-py-3 tw-px-4 tw-font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map(function(log) {
                    var typeInfo = TYPE_LABELS[log.type] || { label: log.type || 'Unknown', color: '#999', icon: 'fa-envelope' };
                    return (
                      <tr key={log._id} className="tw-border-b tw-border-[#f0f0f0] dark:tw-border-[#222] hover:tw-bg-[#fafafa] dark:hover:tw-bg-[#1e1e1e] tw-transition-colors">
                        <td className="tw-py-3 tw-px-4 tw-text-xs tw-text-[#999] tw-whitespace-nowrap">{formatDate(log.createdAt)}</td>
                        <td className="tw-py-3 tw-px-4">
                          <span className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-medium" style={{ backgroundColor: typeInfo.color + '18', color: typeInfo.color }}>
                            <i className={'fa ' + typeInfo.icon} style={{ fontSize: 10 }} />
                            {typeInfo.label}
                          </span>
                        </td>
                        <td className="tw-py-3 tw-px-4 tw-text-xs tw-text-[#666] dark:tw-text-[#aaa] tw-max-w-[200px] tw-truncate">{log.to}</td>
                        <td className="tw-py-3 tw-px-4 tw-text-xs tw-text-[#1a1a1a] dark:tw-text-white tw-max-w-[250px] tw-truncate">{log.subject || '-'}</td>
                        <td className="tw-py-3 tw-px-4">
                          {log.relatedUser ? (
                            <button
                              onClick={function() { self.props.onOpenUserModal && self.props.onOpenUserModal(log.relatedUser._id); }}
                              className="tw-text-xs tw-font-medium tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 hover:tw-text-[#D4A843] tw-text-[#1a1a1a] dark:tw-text-white"
                            >
                              {log.relatedUser.userName}
                            </button>
                          ) : (
                            <span className="tw-text-xs tw-text-[#999]">-</span>
                          )}
                        </td>
                        <td className="tw-py-3 tw-px-4">
                          <span
                            className="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-medium"
                            style={{ backgroundColor: log.status === 'sent' ? 'rgba(16,185,129,0.1)' : 'rgba(239,68,68,0.1)', color: log.status === 'sent' ? '#10B981' : '#EF4444' }}
                          >
                            <i className={'fa ' + (log.status === 'sent' ? 'fa-check' : 'fa-times')} style={{ fontSize: 9 }} />
                            {log.status === 'sent' ? 'Sent' : 'Failed'}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {pagination.pages > 1 && (
              <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-py-3" style={{ borderTop: '1px solid ' + (isDark ? '#2a2a2a' : '#e8e8e8') }}>
                <span className="tw-text-xs tw-text-[#999]">
                  Page {pagination.page} of {pagination.pages}
                </span>
                <div className="tw-flex tw-gap-1">
                  <button
                    onClick={function() { self.fetchLogs(pagination.page - 1); }}
                    disabled={pagination.page <= 1}
                    className="tw-px-3 tw-py-1.5 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
                  >
                    Prev
                  </button>
                  <button
                    onClick={function() { self.fetchLogs(pagination.page + 1); }}
                    disabled={pagination.page >= pagination.pages}
                    className="tw-px-3 tw-py-1.5 tw-rounded tw-text-xs tw-border tw-border-[#d0d0d0] dark:tw-border-[#555] tw-bg-white dark:tw-bg-[#222] tw-text-[#666] dark:tw-text-[#aaa] tw-cursor-pointer disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default AdminNotificationLog;
